import { useEffect, useRef } from 'react';

import OktaSignIn from '@okta/okta-signin-widget';
import PropTypes from 'prop-types';

import { buildWidgetOptions } from '../../../common/auth/oktaconfig';
import { logger } from '../../../common/logger';
import { getAppConfig } from '../../../common/utilities';
import LoginFooter from '../LoginFooter';

import '../../../../../node_modules/@okta/okta-signin-widget/dist/css/okta-sign-in.min.css';

const { lang } = getAppConfig('locale');

const OktaSignInWidget = ({ labels, widgetFooterContent }) => {
  const widgetRef = useRef();

  useEffect(() => {
    if (!widgetRef.current) return null;

    const widgetOptions = buildWidgetOptions(labels, lang);
    const widget = new OktaSignIn(widgetOptions);

    widget
      .showSignInAndRedirect({
        el: widgetRef.current
      })
      .catch(err => {
        logger.error('this function is invoked with errors the login widget cannot recover from', err);
        return null;
      });

    return () => widget.remove();
  }, []);

  return (
    <div className="sign-in-widget">
      <div ref={widgetRef} />
      <LoginFooter
        data={{
          widgetFooterContent
        }}
      />
    </div>
  );
};

OktaSignInWidget.propTypes = {
  labels: PropTypes.instanceOf(Object).isRequired,
  widgetFooterContent: PropTypes.instanceOf(Object).isRequired
};

export default OktaSignInWidget;
